/* tslint:disable */
/* eslint-disable */

/**
 * 0 = InterventionTechnique
 * 1 = Entretien
 * 2 = Tonte
 * 3 = ReparationConteneur
 */
export enum TypeIntervention {
  InterventionTechnique = 0,
  Entretien = 1,
  Tonte = 2,
  ReparationConteneur = 3
}
